import { jsx as _jsx } from 'react/jsx-runtime';
export const IconInfoFilled = (props) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm6 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z',
      fill: 'currentColor',
    }),
  });
IconInfoFilled.displayName = 'IconInfoFilled';
